import React from 'react';
import ReactDOM from 'react-dom/client';
import { TicTacToe } from './TicTacToe';
import './main.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<TicTacToe />);